import { useContext } from 'react';
import { MessagingSocketContext } from '@/components/messaging/MessagingSocketProvider';
import type { MessagingSocketContextValue } from '@/components/messaging/MessagingSocketProvider';

export type { MessagingSocketContextValue };

export function useMessagingSocket(): MessagingSocketContextValue {
  const context = useContext(MessagingSocketContext);
  if (!context) {
    throw new Error('useMessagingSocket must be used within <MessagingSocketProvider>');
  }
  return context;
}
